(() => {
  const root = document.querySelector('[data-machine-finder]');
  if (!root) return;

  const trigger = document.querySelector('a[href*="/collections/destacados?finder=1"]');
  if (!trigger) return;

  const dialog = root.querySelector('[role="dialog"]');
  const steps = Array.from(root.querySelectorAll('[data-machine-finder-step]'));
  const progress = root.querySelector('[data-machine-finder-progress]');
  const stepLabel = root.querySelector('[data-machine-finder-step-label]');
  const backButton = root.querySelector('[data-machine-finder-back]');
  const restartButton = root.querySelector('[data-machine-finder-restart]');
  const resultTitle = root.querySelector('[data-machine-finder-result-title]');
  const resultCopy = root.querySelector('[data-machine-finder-result-copy]');
  const summary = root.querySelector('[data-machine-finder-summary]');
  const resultLink = root.querySelector('[data-machine-finder-result-link]');
  const whatsappLink = root.querySelector('[data-machine-finder-whatsapp]');
  const answers = {};
  const answerLabels = {};
  let currentStep = 1;
  let lastFocus = null;

  const getRecommendation = () => {
    const monthlyVolume = answers.monthly_volume;
    const wantsCafe = answers.goal === 'cafe';

    if (monthlyVolume === 'under_5') {
      return {
        segment: 'hobby',
        title: 'Una tostadora para hobby',
        copy: 'Para menos de 5 kg mensuales conviene comenzar con un equipo compacto, accesible y fácil de aprender.',
        url: '/collections/home-roaster',
      };
    }

    if (monthlyVolume === '5_20') {
      return {
        segment: wantsCafe ? 'small_cafe' : 'initial_micro_roaster',
        title: wantsCafe ? 'Equipos para una cafetería pequeña' : 'Equipos para comenzar como microtostador',
        copy: 'Entre 5 y 20 kg mensuales necesitas equilibrar inversión, facilidad de uso y consistencia entre lotes.',
        url: wantsCafe ? '/collections/cafeterias' : '/collections/emprendedores',
      };
    }

    if (monthlyVolume === '20_40') {
      return {
        segment: wantsCafe ? 'medium_cafe' : 'micro_roaster',
        title: wantsCafe ? 'Equipos para una cafetería mediana' : 'Equipos para microtostadores',
        copy: 'Entre 20 y 40 kg mensuales ya es importante repetir perfiles con precisión y mantener un ritmo estable de producción.',
        url: wantsCafe ? '/collections/cafeterias' : '/collections/microtostadores',
      };
    }

    if (monthlyVolume === '40_100') {
      return {
        segment: 'established_micro_roaster',
        title: 'Equipos para un microtostador consolidado',
        copy: 'Entre 40 y 100 kg mensuales prioriza control, consistencia y capacidad para sostener una operación frecuente.',
        url: '/collections/microtostadores',
      };
    }

    if (monthlyVolume === '100_300') {
      return {
        segment: 'scaling_micro_roaster',
        title: 'Equipos para un microtostador en crecimiento',
        copy: 'Entre 100 y 300 kg mensuales necesitas una solución capaz de escalar, reducir tiempos y conservar la calidad del perfil.',
        url: '/collections/microtostadores',
      };
    }

    return {
      segment: 'professional_micro_roaster',
      title: 'Equipos para producción profesional',
      copy: 'Sobre 300 kg mensuales la capacidad, la continuidad operativa y el control profesional pasan a ser decisivos.',
      url: '/collections/especialidad-pro',
    };
  };

  const track = (eventName, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      source: 'hrc_machine_finder',
      ...extra,
    });
  };

  const showStep = (step) => {
    currentStep = step;
    steps.forEach((item) => {
      item.hidden = item.dataset.machineFinderStep !== String(step);
    });

    const isResult = step === 'result';
    progress.style.width = isResult ? '100%' : `${(Number(step) / 3) * 100}%`;
    stepLabel.textContent = isResult ? 'Recomendación lista' : `Paso ${step} de 3`;
    backButton.hidden = step === 1 || isResult;
    restartButton.hidden = !isResult;

    const heading = root.querySelector(`[data-machine-finder-step="${step}"] h3`);
    if (heading) heading.setAttribute('tabindex', '-1');
    if (heading) heading.focus({ preventScroll: true });
  };

  const buildResult = () => {
    const profile = getRecommendation();
    resultTitle.textContent = profile.title;
    resultCopy.textContent = profile.copy;
    resultLink.href = profile.url;
    summary.innerHTML = Object.values(answerLabels)
      .map((label) => `<span>${label}</span>`)
      .join('');

    const message = [
      'Hola, completé el recomendador de Home Roaster Chile y quisiera afinar mi elección.',
      `Uso: ${answerLabels.goal}.`,
      `Volumen mensual estimado: ${answerLabels.monthly_volume}.`,
      `Prioridad: ${answerLabels.priority}.`,
      `Segmento recomendado: ${profile.title}.`,
    ].join('\n');

    whatsappLink.href = `https://wa.me/${root.dataset.whatsappNumber}?text=${encodeURIComponent(message)}`;
    showStep('result');
    track('machine_finder_complete', {
      goal: answers.goal,
      monthly_volume: answers.monthly_volume,
      priority: answers.priority,
      recommended_segment: profile.segment,
      recommended_collection: profile.url,
    });
  };

  const open = (event) => {
    event.preventDefault();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('machine-finder-open');
    showStep(1);
    track('machine_finder_open', { placement: 'homepage_hero' });
  };

  const close = () => {
    root.hidden = true;
    document.body.classList.remove('machine-finder-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  trigger.addEventListener('click', open);

  root.querySelectorAll('[data-machine-finder-close]').forEach((button) => {
    button.addEventListener('click', close);
  });

  root.querySelectorAll('[data-machine-answer]').forEach((button) => {
    button.addEventListener('click', () => {
      const key = button.dataset.key;
      answers[key] = button.dataset.value;
      answerLabels[key] = button.dataset.label;
      track('machine_finder_answer', {
        step: currentStep,
        question: key,
        answer: button.dataset.value,
      });

      if (currentStep === 3) {
        buildResult();
      } else {
        showStep(currentStep + 1);
      }
    });
  });

  backButton.addEventListener('click', () => showStep(Math.max(1, currentStep - 1)));
  restartButton.addEventListener('click', () => {
    Object.keys(answers).forEach((key) => delete answers[key]);
    Object.keys(answerLabels).forEach((key) => delete answerLabels[key]);
    showStep(1);
    track('machine_finder_restart');
  });

  resultLink.addEventListener('click', () => {
    track('machine_finder_result_click', {
      goal: answers.goal,
      monthly_volume: answers.monthly_volume,
      priority: answers.priority,
      recommended_segment: profile.segment,
      destination: resultLink.getAttribute('href'),
    });
  });

  whatsappLink.addEventListener('click', () => {
    track('machine_finder_whatsapp_click', {
      goal: answers.goal,
      monthly_volume: answers.monthly_volume,
      priority: answers.priority,
      recommended_segment: getRecommendation().segment,
      placement: 'machine_finder_result',
    });
  });

  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      dialog.querySelectorAll('a[href], button:not([hidden]):not([disabled]), [tabindex="0"]')
    ).filter((element) => !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
